import { render, staticRenderFns } from "./IssueToFulcrumModal.vue?vue&type=template&id=0861f30d&scoped=true&"
import script from "./IssueToFulcrumModal.vue?vue&type=script&lang=js&"
export * from "./IssueToFulcrumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861f30d",
  null
  
)

export default component.exports